import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import { View, ViewOpts } from '@play-co/timestep-core/ui';
import Scroll from 'src/game/components/shared/Scroll';
import { CardCollectionState, CardCollectionIcon } from './CardCollectionIcon';
import { chunkArray } from 'src/replicant/utils/array';

export type CollectionListState = { collections: CardCollectionState[] };

/** Options for the collection list and nested popup lifecycle. */
type CardCollectionsListOpts = ViewOpts & {
  onCollectionPopupClose?: () => void | Promise<void>;
};

type CardCollectionLine = [
  CardCollectionState,
  CardCollectionState?,
  CardCollectionState?,
];

export class CardCollectionsList extends View {
  private scroll: Scroll<CardCollectionLine, View>;

  constructor(opts: CardCollectionsListOpts) {
    const { onCollectionPopupClose, ...viewOpts } = opts;
    super(viewOpts);

    this.scroll = new Scroll<CardCollectionLine>({
      superview: this,
      createItem: (superview, _, data) => {
        const line = new FlexBoxView({
          superview,
          width: this.style.width,
          height: 300,
          flex: {
            alignItems: 'center',
            justifyContent: 'space-evenly',
          },
        });

        for (let i = 0; i < 3; i++) {
          const icon = new CardCollectionIcon({
            superview: line,
            onCollectionPopupClose,
          });
          icon.setState(data[i]);
        }

        return line;
      },

      recycle: true,
      setData: (_, icons, view) => {
        icons.forEach((icon, i) => {
          (view.getSubview(i) as CardCollectionIcon)?.setState(icon);
        });
      },
      rect: {
        x: 0,
        y: 0,
        width: this.style.width,
        height: this.style.height,
      },
    });
  }

  public setState(data: CollectionListState) {
    const listData: CardCollectionLine[] = [];

    chunkArray(data.collections, 3).forEach((chunk) => {
      const data = [];
      for (let i = 0; i < 3; i++) {
        data.push(chunk[i]);
      }

      listData.push(data as CardCollectionLine);
    });

    this.scroll.setItems(listData);
  }
}
